import { createAction, props } from '@ngrx/store';
import { CreateApiResponse } from 'src/app/shared/types/accounts';

const accountIsCreated = 'ACCOUNT_IS_CREATED';
const removeRecentAccount = 'REMOVE_RECENT_ACCOUNT';
export const accountIsCreatedAction = createAction(
  accountIsCreated,
  props<{ newAccount: CreateApiResponse['data'] }>()
);

export const removeRecentAccountAction = createAction(removeRecentAccount);
